import validate from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}